// source: pbtypes/gen/user_camera/photo_capture_result.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.user_camera.PhotoCaptureResult', null, global);
goog.exportSymbol('proto.user_camera.PhotoCaptureResult.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.user_camera.PhotoCaptureResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.user_camera.PhotoCaptureResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.user_camera.PhotoCaptureResult.displayName = 'proto.user_camera.PhotoCaptureResult';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.user_camera.PhotoCaptureResult.prototype.toObject = function(opt_includeInstance) {
  return proto.user_camera.PhotoCaptureResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.user_camera.PhotoCaptureResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.user_camera.PhotoCaptureResult.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.user_camera.PhotoCaptureResult}
 */
proto.user_camera.PhotoCaptureResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.user_camera.PhotoCaptureResult;
  return proto.user_camera.PhotoCaptureResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.user_camera.PhotoCaptureResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.user_camera.PhotoCaptureResult}
 */
proto.user_camera.PhotoCaptureResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.user_camera.PhotoCaptureResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.user_camera.PhotoCaptureResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.user_camera.PhotoCaptureResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.user_camera.PhotoCaptureResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.user_camera.PhotoCaptureResult.Enum = {
  CAPTURE_SUCCESSFUL: 0,
  CAPTURE_FAILED_LOW_SPACE: 1,
  CAPTURE_FAILED_CAMERA_ERROR: 2,
  CAPTURE_FAILED_FS_ERROR: 3,
  CAPTURE_FAILED_MODE_ERROR: 4,
  CAPTURE_FAILED_QUEUE_FULL: 5,
  CAPTURE_FAILED_UNSUPPORTED_FORMAT: 6,
  CAPTURE_IN_PROGRESS_EXPOSED: 8,
  READY_FOR_NEXT: 9,
  CAPTURE_DISABLED: 7
};

goog.object.extend(exports, proto.user_camera);
